import { render, staticRenderFns } from "./ModalViewRejectionNote.vue?vue&type=template&id=72075115&"
import script from "./ModalViewRejectionNote.vue?vue&type=script&lang=js&"
export * from "./ModalViewRejectionNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports